/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpacktitle2Inputs */

const en_artifactpacktitle2 = /** @type {(inputs: Artifactpacktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full case pack`)
};

const pt_artifactpacktitle2 = /** @type {(inputs: Artifactpacktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack completo do caso`)
};

/**
* | output |
* | --- |
* | "Full case pack" |
*
* @param {Artifactpacktitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpacktitle2 = /** @type {((inputs?: Artifactpacktitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpacktitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpacktitle2(inputs)
	return pt_artifactpacktitle2(inputs)
});
export { artifactpacktitle2 as "artifactPackTitle" }